import { AxiosError, AxiosRequestConfig } from 'axios';
import { apiGet, apiPost, apiPutFile } from './api';
import {
  IUserAdditionalData,
  ICreateUserAdditionalDataDto,
  IUpdateUserAccountDto,
  IbackofficeUserData
} from '../types/configuration.types';
const { REACT_APP_API_USERS } = process.env;

export const getUserAdditionalDataById = async (userId: number): Promise<IUserAdditionalData[]> => {
  return apiGet<AxiosRequestConfig, IUserAdditionalData[]>(`${REACT_APP_API_USERS}/user-additional-data/${userId}`)
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};

export const createOrUpdateUserAdditionalData = async (
  data: ICreateUserAdditionalDataDto
): Promise<IUserAdditionalData> => {
  return apiPost<AxiosRequestConfig, ICreateUserAdditionalDataDto, IUserAdditionalData>(
    `${REACT_APP_API_USERS}/user-additional-data`,
    data
  )
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};

export const updatePersonalData = async (id: number, formData: IUpdateUserAccountDto, file?: File): Promise<string> => {
  const data = new FormData();
  if (file) data.append('file', file);
  data.append('body', JSON.stringify(formData));
  return apiPutFile<AxiosRequestConfig, IbackofficeUserData>(`${REACT_APP_API_USERS}/user/${id}`, data)
    .then(response => {
      return Promise.resolve(response);
    })
    .catch((error: AxiosError) => {
      Promise.reject(error);
      throw error;
    });
};
